export default __webpack_public_path__ + "img/970a10346185fbe3d50896a61284d5c6.png";